<template>

  <div class="page-content">

    <div class="title">{{ obj.title }}</div>
    <img class="title-img" :src="obj.head_img">
    <div class="subtitle">{{ obj.subtitle }}</div>

    <div class="time">{{ obj.time }}</div>

    <div style="height: 40px"></div>
    <div id="p1" class="content-w">

    </div>
    <div style="height: 40px"></div>
  </div>
</template>

<script>
import $ from "jquery";
import cache from "@/utils/cache";

export default {
  name: "newsDetailPage",
  data() {
    return {obj: {}}
  },
  mounted() {
    this.getData()
  },
  methods: {

    async getData() {
      let ii = setInterval(() => {
        clearInterval(ii)
        this.obj = JSON.parse(cache.getSession('itemnews'))
        $("#p1").empty()
        $("#p1").append(this.obj.detail);

      }, 20)

    }
  }
}
</script>

<style lang="less" scoped>

.page-content {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: white;
  flex-direction: column;

  .title {
    font-size: 30px;
    font-weight: 600;
    color: #333333;
    margin: 40px;
  }

  .title-img {
    margin-left: 40px;
    margin-right: 40px;

  }

  .subtitle {
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
    margin-left: 40px;
    margin-right: 40px;
  }

  .time {
    font-size: 16px;
    color: #999999;
    margin-left: 40px;
    margin-right: 40px;
    margin-top: 10px;
  }

  .content-w {
    margin-top: 20px;
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 30px;
  }
}
</style>
